import React from 'react';
import { Icon } from './Icon.jsx';

/** Input — labeled text field with optional icon, help text and error state. */
export function Input({
  label, hint, error, icon, size = 'md', id, style, containerStyle, disabled, ...rest
}) {
  const [focus, setFocus] = React.useState(false);
  const generatedId = React.useId();
  const rid = id || generatedId;
  const pad = size === 'lg' ? '13px 15px' : size === 'sm' ? '8px 11px' : '11px 13px';
  const fs = size === 'lg' ? 'var(--text-lg)' : size === 'sm' ? 'var(--text-sm)' : 'var(--text-base)';
  const borderColor = error ? 'var(--danger)' : focus ? 'var(--focus-ring)' : 'var(--border-strong)';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, ...containerStyle }}>
      {label && (
        <label htmlFor={rid} style={{ fontFamily: 'var(--font-sans)', fontWeight: 'var(--fw-semibold)', fontSize: 'var(--text-sm)', color: 'var(--text-strong)' }}>
          {label}
        </label>
      )}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        background: disabled ? 'var(--surface-sunken)' : 'var(--surface-card)',
        border: `2px solid ${borderColor}`,
        borderRadius: 'var(--radius-md)',
        padding: pad,
        boxShadow: focus ? `0 0 0 4px ${error ? 'var(--danger-soft)' : 'var(--secondary-soft)'}` : 'none',
        transition: 'border-color var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out)',
        opacity: disabled ? 0.6 : 1,
        ...style,
      }}>
        {icon && <Icon name={icon} size={18} color="var(--text-muted)" />}
        <input
          id={rid}
          disabled={disabled}
          onFocus={(e) => { setFocus(true); rest.onFocus?.(e); }}
          onBlur={(e) => { setFocus(false); rest.onBlur?.(e); }}
          style={{
            flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent',
            fontFamily: 'var(--font-sans)', fontSize: fs, fontWeight: 'var(--fw-medium)',
            color: 'var(--text-strong)',
          }}
          {...rest}
        />
      </div>
      {(hint || error) && (
        <span style={{ fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: error ? 'var(--danger)' : 'var(--text-muted)' }}>
          {error || hint}
        </span>
      )}
    </div>
  );
}
